module.exports = __webpack_public_path__ + "img/1453089227.31fbdf9c.jpg";